import React from "react";
import {Button, Grid, Typography} from "@mui/material";
import {AccountType} from "../../../components/constants/securspace-constants";
import {Link} from "react-router";
import {styled} from "@mui/material/styles";

const USER_BASED_REDIRECT_PATH = Object.freeze({
  [AccountType.SUPPLIER]: '/supplier-signup',
  [AccountType.BUYER]: '/buyer-signup',
});

const SwitchAccountTypeTitle = styled(Typography)(() => ({
  fontFamily: 'Satoshi-Variable',
  fontWeight: 700,
  fontSize: '1.43rem',
  lineHeight: '1.71rem',
}));

const SwitchAccountTypeTitleContrast = styled(SwitchAccountTypeTitle)(({theme}) => ({
  color: theme.palette.primary.contrastText,
}));

const SwitchAccountTypeButton = styled(Button)(({theme}) => ({
  backgroundColor: `${theme.palette.primary.main} !important`,
  padding: '1.57rem 2.97rem !important',
  width: '100%',
  borderRadius: '0.57rem !important',
}));

const SwitchAccountTypeButtonContent = styled(Grid)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  width: '100%',
  gap: '0.57rem',
  textTransform: 'none',
  color: theme.palette.secondary.contrastText,
}));

const LearnMoreText = styled(Typography)(({theme}) => ({
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '0.93rem',
  lineHeight: '169%',
  letterSpacing: '0.03rem',
  color: theme.palette.secondary.contrastText,
}));

export const SwitchToPartnerButton = () => {

  const routerLink = React.forwardRef((props, ref) => {
    return <Link ref={ref} to={USER_BASED_REDIRECT_PATH[AccountType.SUPPLIER]} {...props}/>;
  });
  routerLink.displayName = 'RouterLink';

  return (
    <SwitchAccountTypeButton component={routerLink}>
      <SwitchAccountTypeButtonContent item>
        <Grid item>
          <SwitchAccountTypeTitleContrast component='h6'>Sign up as a Supplier</SwitchAccountTypeTitleContrast>
          <Typography variant="subtitle1">List your available parking and storage space</Typography>
        </Grid>
        <LearnMoreText variant="subtitle1">LEARN MORE</LearnMoreText>
      </SwitchAccountTypeButtonContent>
    </SwitchAccountTypeButton>
  );
};

export const SwitchToCustomerButton = () => {

  const RouterLink = React.forwardRef((props, ref) => {
    return <Link ref={ref} to={USER_BASED_REDIRECT_PATH[AccountType.BUYER]} {...props}/>;
  });
  RouterLink.displayName = "RouterLink";

  return (
    <SwitchAccountTypeButton component={RouterLink}>
      <SwitchAccountTypeButtonContent item>
        <Grid item>
          <SwitchAccountTypeTitle component='h6'>Sign up as a Buyer</SwitchAccountTypeTitle>
          <Typography variant="subtitle1">Reserve available parking and storage space</Typography>
        </Grid>
        <LearnMoreText variant="subtitle1">LEARN MORE</LearnMoreText>
      </SwitchAccountTypeButtonContent>
    </SwitchAccountTypeButton>
  );
};
